import React from 'react';

function BibReadingHeaderRow() {
	return (
		<tr><th>Pag.</th><th>Id</th><th>Inläsningstid</th><th>Nummer</th></tr>
	);
}
export default BibReadingHeaderRow;